import { createClient } from '@supabase/supabase-js';

// החלף את אלו במפתחות האמיתיים שלך מ-Supabase Settings -> API
export const SUPABASE_URL = 'https://tvikszmwgmyvyfujbvze.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR2aWtzem13Z215dnlmdWpidnplIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ4NTUyODMsImV4cCI6MjA4MDQzMTI4M30.LxumnfkBZgOz9baKfwaF_iC7KkDkQiyrRvK0Kbju-QU';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);